/**
 * Guest order tokens.
 *
 * A guest has no account, so the opaque token the engine returns at checkout is
 * the only proof they own the order. Where it lives matters:
 *
 *   - sessionStorage, not localStorage: it dies with the tab, so a shared or
 *     public machine does not keep a working ticket link lying around.
 *   - never the URL: query strings land in history, bookmarks, referrer headers
 *     and server logs. The token travels in a request header instead.
 *
 * A signed-in buyer needs none of this — the engine authorizes them by
 * ownership — so this is purely the guest path.
 */

const PREFIX = 'voleto.order.';

function storage(): Storage | null {
  try {
    return window.sessionStorage;
  } catch {
    // Storage can throw in private modes / blocked-cookie settings.
    return null;
  }
}

export function rememberOrderToken(orderId: string, token: string): void {
  storage()?.setItem(`${PREFIX}${orderId}`, token);
}

export function recallOrderToken(orderId: string): string | null {
  return storage()?.getItem(`${PREFIX}${orderId}`) ?? null;
}

export function forgetOrderToken(orderId: string): void {
  storage()?.removeItem(`${PREFIX}${orderId}`);
}
